import { ApiError } from '@/api/types'
import { getErrorMessage } from '@/shared/utils/error-codes'

/**
 * The message for a refused stock-usage, variant or delete request
 * (CHG-2026-09-stock-usage-and-price-twins). The code's German text comes from the shared
 * `errors` namespace; refusals that name a product (`part_is_dish` with `sku`, `product_is_part`
 * with `dishes`, `product_has_no_stock` with `skus`) get it appended, so the manager sees which
 * row or dish is meant.
 */
export function describeStockError(err: unknown, fallback: string): string {
  if (!(err instanceof ApiError)) return fallback
  const message = getErrorMessage(err.status, err.code)
  const data = (err.data ?? {}) as {
    sku?: unknown
    skus?: unknown
    dishes?: unknown
  }
  const named: Array<string> = []
  if (typeof data.sku === 'string') named.push(data.sku)
  if (Array.isArray(data.skus))
    named.push(...data.skus.filter((s): s is string => typeof s === 'string'))
  if (Array.isArray(data.dishes)) {
    for (const dish of data.dishes as Array<{ name?: string; sku?: string }>) {
      const label = dish.name ?? dish.sku
      if (label) named.push(label)
    }
  }
  return named.length > 0 ? `${message} (${named.join(', ')})` : message
}

/** The structured body of a refusal, when the server sent one. */
export function conflictData<T>(err: unknown, code: string): T | null {
  if (err instanceof ApiError && err.status === 409 && err.code === code) {
    return (err.data ?? null) as T | null
  }
  return null
}
